export default __webpack_public_path__ + "media/images/opengraph-image-3aed610959858caf54d399a1e662454d.jpg";